import { useSelector } from 'react-redux';

import withErrorBoundary from 'common/components/withErrorBoundary/withErrorBoundary';
import {
  type TGlobalFunctionTyped,
  useTranslation,
} from 'common/hooks/useTranslation';
import { useUser } from 'modules/app/hooks/useUser';
import {
  getHasControllerHomepage,
  getHasRequesterHomepage,
} from 'src/core/selectors/globalSelectors';

import { DisplayModeSwitch } from './components/DisplayModeSwitch';
import { WelcomePanelContent } from './components/WelcomePanelContent/WelcomePanelContent';

export const WelcomePanel = withErrorBoundary({
  team: 'finance-accountant',
  scope: 'HomePage::MorningPanel',
})(() => {
  const { t } = useTranslation('global');

  const user = useUser();

  const hasRequesterHomepage = useSelector(getHasRequesterHomepage);
  const hasControllerHomepage = useSelector(getHasControllerHomepage);
  const isSwitchDisplayed = hasRequesterHomepage && hasControllerHomepage;

  const welcomeMessage = getWelcomeMessage(t, { name: user.first_name });

  return (
    <div className="flex flex-col justify-center gap-8">
      <div className="flex items-center justify-between gap-16">
        <h1 className="text-content-primary heading-xl">{welcomeMessage}</h1>
        {isSwitchDisplayed && <DisplayModeSwitch />}
      </div>
      <WelcomePanelContent />
    </div>
  );
});

const getWelcomeMessage = (
  t: TGlobalFunctionTyped,
  params: { name: string },
): string => {
  const currentHours = new Date().getHours();
  if (currentHours >= 5 && currentHours < 12) {
    return t('homepage.welcome.morning', params);
  }
  if (currentHours >= 12 && currentHours < 18) {
    return t('homepage.welcome.hello', params);
  }

  return t('homepage.welcome.evening', params);
};
